import { type Observable } from 'rxjs'
import type { GetCurrentMemberFn } from '@/features/iam'
import { createInternalFeatureLoader } from '@/utils/feature-loading-util'
import type {
  ListPublishedLegendsFn,
  ListSearchableJobsFn,
} from '@/features/jobs'
import type { SnackbarFactory, StartHandoffFn } from '@/features/shell'
import type { EnsureTermsAcceptanceFn } from '@/features/account'
import type { CreateNewDraftJobFn } from '@/features/jobs/internal'
import type { JobListViewModelFactory } from '@/features/jobs/list/JobListViewModel'
import type { SearchableJob } from '@/features/jobs/list/SearchableJob'
import type { SessionOptions } from '@/features/iam/auth/SessionOptions'

/**
 * Options for the {@link DashboardFeature}.
 */
export interface DashboardFeatureOptions {
  token$: Observable<string>
  getCurrentMember: GetCurrentMemberFn
  listPublishedLegends: ListPublishedLegendsFn
  createNewDraftJob: CreateNewDraftJobFn
  createJobListViewModel: PromiseLike<JobListViewModelFactory>
  newSearchableJob$: Observable<SearchableJob>
  listSearchableJobs: ListSearchableJobsFn
  newSnackbar: SnackbarFactory
  ensureTermsAcceptance: EnsureTermsAcceptanceFn
  startHandoff: StartHandoffFn
  sessionOptions$: Observable<SessionOptions>
}

/**
 * Everything related to dashboard.
 */
export type DashboardFeature = ReturnType<typeof DashboardFeature>

export function DashboardFeature(options: DashboardFeatureOptions) {
  const internal = createInternalFeatureLoader(
    () => import('./internal'),
    (module) => module.InternalDashboardFeature(options),
  )

  return {
    // Internal
    internal,

    // Public
  }
}
